export default "__VITE_ASSET__K8amx7LP__"